// extracted by mini-css-extract-plugin
module.exports = {"container":"v_option_container__1PSq8","icon":"v_option_icon__1E8dn"};